import { render } from "./Pewartaan.vue?vue&type=template&id=10533b40"
import script from "./Pewartaan.vue?vue&type=script&lang=js"
export * from "./Pewartaan.vue?vue&type=script&lang=js"

import "./Pewartaan.vue?vue&type=style&index=0&id=10533b40&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__